import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const unitsSlice = createCrudSlice({
  name: 'units',
  max: 10,
  sort: -1,
})

export const UnitsActions = unitsSlice.actions

export const UnitsSelectors = {
  ...createCrudSelectors({ name: 'units' }),
}

export default unitsSlice.reducer
